'use client';
import { useMemo } from 'react';
import { isFunction, omitUndefined } from '@s7/utils';
import { useTheme } from '../theming/propagation/ThemeProvider.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function useProps(__ident, defaultProps, props) {
    var theme = useTheme();
    return useMemo(function() {
        var _theme_components___ident, _theme_components;
        var _themeProps = (_theme_components = theme.components) == null ? void 0 : (_theme_components___ident = _theme_components[__ident]) == null ? void 0 : _theme_components___ident.props;
        var themeProps = isFunction(_themeProps) ? _themeProps(theme) : _themeProps;
        var mergedProps = _extends({}, defaultProps, themeProps, omitUndefined(props));
        var classNames = mergedProps.classNames, styles = mergedProps.styles, size = mergedProps.size, variant = mergedProps.variant, others = _object_without_properties_loose(mergedProps, [
            "classNames",
            "styles",
            "size",
            "variant"
        ]);
        return [
            others,
            {
                classNames: classNames,
                styles: styles,
                size: size,
                variant: variant
            }
        ];
    }, [
        props
    ]);
}

export { useProps };
